import React from 'react';
import {Button} from 'reactstrap';
import {BanIcon} from 'lucide-react';
import Icon from '../shared/Icon.tsx';
import ColorPickerComponent from '../shared/ColorPicker.tsx';
import {NormalizedColor, HTMLColor} from './types.ts';
import getColorHexValue from './getColorHexValue.ts';

interface OptionalColorPickerProps {
    color: NormalizedColor | HTMLColor | null | undefined;
    // The swatch shown while there's no colour (what the scene shows then).
    noneColor: HTMLColor;
    noneLabel: string;
    noneTitle: string;
    onChange: (color: HTMLColor | null) => void;
}

// A colour that can also be "none", stored as null.
const OptionalColorPicker: React.FC<OptionalColorPickerProps> = ({
    color,
    noneColor,
    noneLabel,
    noneTitle,
    onChange
}) => {
    const isSet = color !== undefined && color !== null;

    return (
        <div className="d-flex align-items-start gap-1">
            <ColorPickerComponent
                color={isSet ? getColorHexValue(color) : noneColor}
                onChange={onChange}
            />
            <Button
                color="secondary"
                onClick={() => onChange(null)}
                disabled={!isSet}
                title={noneTitle}
                aria-label={noneTitle}
            >
                <Icon icon={BanIcon} />
            </Button>
            {!isSet && <span className="form-text">{noneLabel}</span>}
        </div>
    );
};

export default OptionalColorPicker;
